var map = {
	"./address_image.svg": 167,
	"./animated_ashutosh.png": 168,
	"./animated_logo.svg": 169,
	"./avatar.png": 96,
	"./avatar_2.jpg": 170,
	"./blogs_image.svg": 171,
	"./cloud_infrastructure.svg": 172,
	"./codeInLogo.png": 173,
	"./contactMail.png": 174,
	"./coursera_logo.png": 175,
	"./data_science.svg": 176,
	"./deeplearning_ai_logo.png": 177,
	"./delhivery_logo.png": 178,
	"./developerActivity.svg": 179,
	"./dsc_logo.png": 180,
	"./education.svg": 181,
	"./experience.svg": 182,
	"./feelingProud.svg": 183,
	"./freecopy_logo.png": 184,
	"./fullstack.svg": 185,
	"./gcp_logo.png": 186,
	"./github_logo.png": 187,
	"./googleAssistant.jpg": 188,
	"./googleAssistant.svg": 189,
	"./google_logo.png": 190,
	"./ibm_logo.png": 191,
	"./iiitk_logo.png": 192,
	"./intel_logo.jpg": 193,
	"./iu_logo.png": 194,
	"./jsFramework.svg": 195,
	"./legato_logo.png": 196,
	"./manOnTable.svg": 197,
	"./microsoft_logo.png": 198,
	"./minnesota_logo.png": 199,
	"./mozilla_logo.png": 200,
	"./muffito_logo.png": 201,
	"./nextuLogo.jpg": 202,
	"./nptel_logo.png": 203,
	"./portfolio.gif": 204,
	"./programmer.svg": 205,
	"./projects_image.svg": 206,
	"./pwa.png": 207,
	"./saayaHealthLogo.png": 208,
	"./sense_logo.jpg": 209,
	"./stanford_logo.png": 210,
	"./talksCardBack.svg": 211,
	"./talksCardBackAlt.svg": 212,
	"./tiktok_logo.png": 213,
	"./tuong_anime.png": 214,
	"./udemy_logo.png": 215,
	"./ui_ux_design.svg": 216,
	"./uit_logo.png": 217,
	"./uit_logo.png.webp": 218,
	"./wata_logo.png": 219,
	"./wata_software_logo.png": 220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;